import { noticeDismissDays } from "src/utils/notice-dismissal";
import { Alert, AlertTitle, Button, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const prioritySeverity = {
  HIGH: "error",
  NORMAL: "info",
  LOW: "success",
};

export const NoticeBanner = (props) => {
  const { notices, onClose, onDismiss } = props;

  if (!notices || notices.length === 0) return null;

  return (
    <Stack spacing={0}>
      {notices.map((notice) => (
        <Alert
          key={notice.noticeId}
          severity={prioritySeverity[notice.priority] || "info"}
          variant="filled"
          sx={{ borderRadius: 0 }}
          action={
            <Stack
              direction="row"
              spacing={0}
              sx={{ flexWrap: "wrap", justifyContent: "flex-end" }}
            >
              <Button
                size="small"
                color="inherit"
                onClick={() => onDismiss(notice.noticeId, noticeDismissDays(notice))}
              >
                {noticeDismissDays(notice) === 7 ? "1주일간 안보기" : "1일간 안보기"}
              </Button>
              <IconButton
                size="small"
                color="inherit"
                onClick={() => onClose(notice.noticeId)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Stack>
          }
        >
          {notice.title && <AlertTitle>{notice.title}</AlertTitle>}
          <span dangerouslySetInnerHTML={{ __html: notice.content }} />
        </Alert>
      ))}
    </Stack>
  );
};
